import { useAuth } from "@/auth/AuthProvider";

export const UserIdentity = ({ className = "" }) => {
    const { user } = useAuth();
    const name = String(user?.name || "").trim();
    const subtitle = [user?.designation, user?.locationName]
        .map((value) => String(value || "").trim())
        .filter(Boolean)
        .join(" · ");

    if (!name && !subtitle) return null;

    return (
        <div
            className={`min-w-0 max-w-[7.5rem] text-right sm:max-w-[12rem] ${className}`}
            aria-label={[name, subtitle].filter(Boolean).join(", ")}
        >
            {name && (
                <p className="truncate text-xs font-semibold leading-4 text-foreground" title={name}>
                    {name}
                </p>
            )}
            {subtitle && (
                <p className="truncate text-[10px] leading-4 text-muted-foreground sm:text-[11px]" title={subtitle}>
                    {subtitle}
                </p>
            )}
        </div>
    );
};
